import { useState } from "react";
import PublicNav from "../Components/PublicNav";
import Footer from "../Components/Footer";
import { useNavigate } from "react-router-dom";

const FAQS = [
  {
    q: "What is RIRA?",
    a: "RIRA (Review Intelligence Response Assistant) is a SaaS platform that helps business owners monitor, analyze, and respond to customer reviews. It connects to your Google Business Profile and uses AI to deliver insights, smart reply drafts, and competitor benchmarks.",
  },
  {
    q: "How does RIRA connect to Google?",
    a: "RIRA uses Google's official OAuth 2.0 flow to securely connect to your Google Business Profile. We never store your Google password — only a secure access token that you can revoke at any time from your Settings page.",
  },
  {
    q: "Is my data secure?",
    a: "Yes. RIRA uses industry-standard security practices including HTTPS encryption, JWT-based authentication, and PBKDF2 password hashing. Your review data is used only to generate insights for your account and is never sold or shared.",
  },
  {
    q: "What is the difference between the plans?",
    a: "The Starter plan is free and gives you basic rating summaries with up to 5 searches per month. The Pro plan ($9.99/month) unlocks AI reply drafts, sentiment analysis, competitor benchmarking, keyword tracking, and CSV/PDF exports. The Business plan ($24.99/month) adds email alerts for bad reviews, weekly digest emails, multi-location support, and response rate tracking.",
  },
  {
    q: "How does AI reply drafting work?",
    a: "Open any review in your dashboard and click 'Draft Reply'. RIRA sends the review to our AI and generates a professional response in seconds. Choose from three tones — Professional, Friendly, or Empathetic — edit the draft, then post it directly to Google.",
  },
  {
    q: "Can I cancel my subscription at any time?",
    a: "Yes. You can cancel at any time from your Settings page. You retain full access until the end of your current billing period. No hidden cancellation fees.",
  },
  {
    q: "Does RIRA support multiple business locations?",
    a: "Yes — the Business plan includes multi-location support. Connect your Google Business Profile and switch between locations from the Settings page without signing out.",
  },
  {
    q: "How do review alerts work?",
    a: "On the Business plan, RIRA monitors your Google reviews and sends you an immediate email when a 1 or 2-star review comes in. The alert includes the review text and a direct link so you can reply right away.",
  },
  {
    q: "Can I try RIRA without a credit card?",
    a: "Yes. The Starter plan is completely free and requires no credit card. Explore the dashboard and rating summaries before deciding to upgrade.",
  },
  {
    q: "What is competitor benchmarking?",
    a: "Competitor benchmarking lets you compare your business side-by-side with up to 2 competitors. You see who leads on average rating, positive sentiment percentage, top keywords, and response rate — so you always know where you stand.",
  },
];

function FAQItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`ip-faq-item ${open ? "ip-faq-item--open" : ""}`}>
      <button className="ip-faq-q" onClick={() => setOpen((o) => !o)}>
        <span>{q}</span>
        <span className="ip-faq-icon">{open ? "−" : "+"}</span>
      </button>
      {open && <div className="ip-faq-a">{a}</div>}
    </div>
  );
}

function FAQPage() {
  const navigate = useNavigate();
  return (
    <div className="lp-page">
      <PublicNav />

      <section className="ip-hero">
        <div className="ip-hero-inner">
          <div className="lp-section-label">FAQ</div>
          <h1 className="ip-hero-title">Frequently asked questions</h1>
          <p className="ip-hero-sub">
            Can't find your answer?{" "}
            <button className="ip-link-btn" onClick={() => navigate("/contact")}>
              Contact us
            </button>
            .
          </p>
        </div>
      </section>

      <section className="ip-section">
        <div className="ip-section-inner ip-faq-inner">
          {FAQS.map((f) => (
            <FAQItem key={f.q} {...f} />
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default FAQPage;
